/* VIROOT theme — vanilla JS, no dependencies */

/* iOS Safari treats a tap on any element with a :hover/:active style as a
   "simulate hover first" gesture, requiring a second tap to actually fire the
   click — regardless of touch-action CSS. A no-op touchstart listener on the
   document is the standard fix: it tells Safari real touch handling is
   present, so it skips the hover-simulation step and the first tap clicks
   immediately. */
document.addEventListener('touchstart', function () {}, { passive: true });

/* Maximum units of any single variant allowed in the cart. Enforced in four
   places, because each is reachable on its own: the product-page stepper, the
   add-to-bag request (which ADDS to whatever is already in the cart), the cart
   page rows, and the cart drawer rows. Shopify itself does not enforce this —
   the real backstop is the per-variant inventory limit — so treat this as a
   UX cap, not a security control. */
window.VIROOT_MAX_PER_ITEM = 4;
window.virootClampQty = function (q, min) {
  q = parseInt(q, 10);
  if (isNaN(q)) q = min;
  return Math.max(min, Math.min(window.VIROOT_MAX_PER_ITEM, q));
};

/* Shared cart-badge helper: sets the count and pops the badge only when it
   goes up, so a decrease (removing an item) doesn't bounce. Used by every
   cart-count updater across the theme. */
window.virootSetCartCount = function (el, value) {
  var prev = parseInt(el.textContent, 10);
  var next = parseInt(value, 10) || 0;
  el.textContent = next;
  el.hidden = next === 0;
  if (next > prev) {
    el.classList.remove('cart-count-pop');
    void el.offsetWidth; /* restart the animation if it's already mid-pop */
    el.classList.add('cart-count-pop');
  }
};

(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     MOBILE NAV
  --------------------------------------------------------------------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    /* Plain `overflow:hidden` on <body> doesn't reliably block touch/rubber-band
       scrolling on iOS Safari — the page behind the drawer could still scroll,
       which showed through as background "bleeding" into the header strip
       above the drawer. Freezing body position (and restoring the exact
       scroll offset on close) is the robust cross-browser fix. */
    var lockedScrollY = 0;
    function lockScroll() {
      lockedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = (-lockedScrollY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedScrollY);
    }

    function close() {
      nav.classList.remove('open');
      toggle.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      unlockScroll();
    }
    function toggleOpen() {
      var isOpen = nav.classList.toggle('open');
      toggle.classList.toggle('open', isOpen);
      toggle.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) lockScroll(); else unlockScroll();
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('open')) close();
    });

    toggle.addEventListener('click', toggleOpen);

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (link && nav.contains(link)) close();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024) close();
    });
  }

  /* ---------------------------------------------------------------------
     ACCORDION (product page sections)
  --------------------------------------------------------------------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-toggle]').forEach(function (el) {
      var sec = el.closest('.pdp-sec');
      if (!sec) return;
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-expanded', sec.classList.contains('open') ? 'true' : 'false');
      function toggle() {
        var open = sec.classList.toggle('open');
        el.setAttribute('aria-expanded', String(open));
      }
      el.addEventListener('click', toggle);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  /* ---------------------------------------------------------------------
     QUANTITY STEPPERS (generic — product form + cart lines)
  --------------------------------------------------------------------- */
  function initProductQty() {
    var minus = document.querySelector('[data-qty-minus]');
    var plus = document.querySelector('[data-qty-plus]');
    var display = document.querySelector('[data-qty-value]');
    var input = document.querySelector('[data-qty-input]');
    if (!minus || !plus || !display || !input) return;

    function current() {
      var v = parseInt(display.textContent, 10);
      return isNaN(v) ? 1 : v;
    }
    function set(v) {
      v = window.virootClampQty(v, 1);
      display.textContent = v;
      input.value = v;
      /* Dead-end the stepper at the cap rather than letting it look broken. */
      plus.disabled = v >= window.VIROOT_MAX_PER_ITEM;
      minus.disabled = v <= 1;
    }
    minus.addEventListener('click', function () { set(current() - 1); });
    plus.addEventListener('click', function () { set(current() + 1); });
    set(current());
  }

  function initCartQty() {
    var page = document.querySelector('.cart-page');
    if (!page || !document.querySelector('.cart-form')) return;
    var summary = page.querySelector('.cart-summary');
    var threshold = summary ? (parseInt(summary.getAttribute('data-free-ship-threshold'), 10) || 0) : 0;
    var pending = null;
    /* Bumped per request so a slow earlier response can't overwrite the
       quantities a later one already settled. Without it, two edits in quick
       succession whose responses land out of order leave the page showing
       stale numbers that disagree with the real cart. */
    var syncSeq = 0;

    function money(c) { var n = Math.round(c) / 100, s = (n % 1 === 0 ? String(n) : n.toFixed(2)), p = s.split('.'), i = p[0], l = i.length > 3 ? i.slice(-3) : i, rr = i.length > 3 ? i.slice(0, -3) : ''; if (rr) l = rr.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + l; return '₹ ' + l + (p[1] ? '.' + p[1] : ''); }

    function updateCounts(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        window.virootSetCartCount(el, count);
      });
    }

    function renderNudge(subtotal) {
      var box = page.querySelector('[data-ship-nudge]');
      if (!box || threshold <= 0) return;
      if (subtotal >= threshold) {
        box.innerHTML = '<div class="cart-ship-nudge cart-ship-nudge--done"><span class="d"></span>You’ve unlocked <strong>free delivery.</strong></div>';
      } else {
        var pct = Math.min(100, Math.round(subtotal * 100 / threshold));
        box.innerHTML = '<div class="cart-ship-nudge">Add <strong>' + money(threshold - subtotal) + '</strong> more for free delivery.<div class="cart-ship-bar"><span style="width:' + pct + '%;"></span></div></div>';
      }
    }

    /* Instant, optimistic recompute straight from the DOM — no network wait. */
    function recompute() {
      var subtotal = 0, count = 0;
      page.querySelectorAll('[data-cart-line]').forEach(function (line) {
        var unit = parseInt(line.getAttribute('data-unit-price'), 10) || 0;
        var input = line.querySelector('[data-cart-qty-input]');
        var q = Math.max(0, parseInt(input.value, 10) || 0);
        subtotal += unit * q; count += q;
        var priceEl = line.querySelector('.cart-line-price');
        if (priceEl) priceEl.textContent = money(unit * q);
        line.style.opacity = q === 0 ? '0.4' : '';
      });
      var sub = page.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = money(subtotal);
      updateCounts(count);
      renderNudge(subtotal);
    }

    /* Reconcile against the authoritative cart after the debounced server sync. */
    function reconcile(cart) {
      if (cart.item_count === 0) { window.location.reload(); return; }
      var byKey = {};
      cart.items.forEach(function (it) { byKey[it.key] = it; });
      page.querySelectorAll('[data-cart-line]').forEach(function (line) {
        var it = byKey[line.getAttribute('data-cart-line')];
        if (!it) { line.remove(); return; }
        var input = line.querySelector('[data-cart-qty-input]');
        if (input && document.activeElement !== input) input.value = it.quantity;
        line.setAttribute('data-unit-price', it.final_price);
        var priceEl = line.querySelector('.cart-line-price');
        if (priceEl) priceEl.textContent = money(it.final_line_price);
        line.style.opacity = '';
      });
      var sub = page.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = money(cart.total_price);
      updateCounts(cart.item_count);
      renderNudge(cart.total_price);
    }

    function sync() {
      var updates = {};
      page.querySelectorAll('[data-cart-line]').forEach(function (line) {
        var input = line.querySelector('[data-cart-qty-input]');
        updates[line.getAttribute('data-cart-line')] = Math.max(0, parseInt(input.value, 10) || 0);
      });
      var mySeq = ++syncSeq;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (mySeq !== syncSeq) return; /* superseded by a newer sync */
          reconcile(cart);
        })
        .catch(function () { window.location.reload(); });
    }

    function scheduleSync() {
      if (pending) clearTimeout(pending);
      pending = setTimeout(sync, 400);
    }

    /* min 0, not 1 — on the cart page zero is how a row is removed. */
    function setQty(line, q) {
      line.querySelector('[data-cart-qty-input]').value = window.virootClampQty(q, 0);
      recompute();
      scheduleSync();
    }

    page.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-cart-qty-minus]');
      var plus = e.target.closest('[data-cart-qty-plus]');
      var rm = e.target.closest('[data-cart-remove]');
      if (minus) { var l = minus.closest('[data-cart-line]'); setQty(l, (parseInt(l.querySelector('[data-cart-qty-input]').value, 10) || 0) - 1); }
      else if (plus) { var l2 = plus.closest('[data-cart-line]'); setQty(l2, (parseInt(l2.querySelector('[data-cart-qty-input]').value, 10) || 0) + 1); }
      else if (rm) { e.preventDefault(); setQty(rm.closest('[data-cart-line]'), 0); }
    });

    page.addEventListener('input', function (e) {
      if (!e.target.closest('[data-cart-qty-input]')) return;
      recompute(); scheduleSync();
    });
    /* Clamp on change, not input — rewriting the field mid-keystroke fights
       the person typing. This also catches a value typed straight past the cap. */
    page.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      input.value = window.virootClampQty(input.value, 0);
      recompute(); scheduleSync();
    });
  }

  /* ---------------------------------------------------------------------
     PRODUCT VARIANT PICKER
  --------------------------------------------------------------------- */
  function formatMoney(cents) {
    var n = cents / 100;
    return '₹ ' + (n % 1 === 0 ? n.toString() : n.toFixed(2));
  }
  function fmtSize(s) {
    if (!s) return s;
    return String(s)
      .replace(/grams?\s+each/gi, 'g each')
      .replace(/grams?/gi, 'g')
      .replace(/(\d)\s*g/gi, '$1 g')
      .replace(/\s+/g, ' ').trim();
  }

  function initVariantPicker() {
    var form = document.getElementById('ProductForm');
    if (!form) return;
    var jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var groups = form.querySelectorAll('.pdp-variants');
    var idInput = form.querySelector('[data-variant-id-input]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var buyBtn = form.querySelector('[data-buy-now]');
    var buyActionsWrap = form.querySelector('[data-buy-actions]');
    var reserveWrap = document.querySelector('[data-reserve-wrap]');
    var reserveLink = document.querySelector('[data-reserve-link]');
    var lowStockNote = document.querySelector('[data-lowstock-note]');
    var lowStockCount = document.querySelector('[data-lowstock-count]');

    function selectedOptions() {
      var opts = [];
      groups.forEach(function (group) {
        var active = group.querySelector('.vbtn.active');
        opts.push(active ? active.getAttribute('data-option-value') : null);
      });
      return opts;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        var vOpts = [v.option1, v.option2, v.option3];
        return opts.every(function (val, i) { return val === null || vOpts[i] === val; });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      idInput.value = variant.id;
      if (groups.length === 1) {
        var lbl = form.querySelector('.pdp-lbl');
        if (lbl) {
          var nm = lbl.textContent.split('—')[0].trim();
          lbl.textContent = nm + ' — ' + fmtSize(variant.title);
        }
      }
      if (priceEl) {
        priceEl.innerHTML = formatMoney(variant.price) +
          (variant.compare_at_price && variant.compare_at_price > variant.price
            ? ' <s style="opacity:.5;margin-left:8px;font-size:0.85em;">' + formatMoney(variant.compare_at_price) + '</s>'
            : '');
      }
      var available = variant.available;
      [addBtn, buyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
      });

      /* Keep the reserve link pointed at the size the customer actually picked.
         This is deliberately independent of the show/hide logic below: when a
         product is sold out in EVERY size, main-product.liquid renders the
         reserve link on its own, with no [data-buy-actions] or
         [data-reserve-wrap] around it. Guarding the href update behind those
         two left the link stuck on the first variant, so every pre-order from
         a fully sold-out product arrived with the wrong size. */
      if (reserveLink) {
        var spice = reserveLink.getAttribute('data-preorder-spice') || '';
        reserveLink.href = '/pages/pre-order?spice=' + encodeURIComponent(spice) +
          '&size=' + encodeURIComponent(variant.title);
      }

      /* This specific size sold out (but the product overall still has stock
         elsewhere) — swap Add to Bag / Buy Now for a "reserve this size"
         pre-order link instead of leaving a dead disabled button. */
      if (buyActionsWrap && reserveWrap) {
        buyActionsWrap.hidden = !available;
        reserveWrap.hidden = available;
      }

      /* Live "Only N left in stock" — updates as the customer switches sizes,
         only for tracked variants sitting at 5 units or fewer. */
      if (lowStockNote && lowStockCount) {
        var showLowStock = available && variant.inventory_management === 'shopify' &&
          variant.inventory_quantity > 0 && variant.inventory_quantity <= 5;
        lowStockNote.hidden = !showLowStock;
        if (showLowStock) lowStockCount.textContent = variant.inventory_quantity;
      }
    }

    groups.forEach(function (group) {
      group.querySelectorAll('.vbtn').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.classList.contains('active') ? 'true' : 'false');
        btn.addEventListener('click', function () {
          group.querySelectorAll('.vbtn').forEach(function (b) {
            b.classList.remove('active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('active');
          btn.setAttribute('aria-pressed', 'true');
          var variant = matchVariant(selectedOptions());
          applyVariant(variant);
        });
      });
    });

    /* Buy Now should go straight to checkout, Add to Bag should stay on page */
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var returnInput = form.querySelector('[data-return-to-input]');
        if (returnInput) returnInput.value = '/checkout';
      });
    }

    if (addBtn) {
      addBtn.setAttribute('data-label-available', addBtn.textContent);
      var addedOpenTimer, addedResetTimer;
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        var formData = new FormData(form);
        formData.delete('checkout');
        var message = document.querySelector('[data-cart-message]');
        addBtn.disabled = true;

        var MAX = window.VIROOT_MAX_PER_ITEM;
        var variantId = String(idInput.value);
        var wanted = window.virootClampQty(formData.get('quantity'), 1);

        /* /cart/add.js ADDS to whatever is already in the cart, so the cap has
           to account for the existing line — otherwise 3 in the cart + "add 2"
           silently becomes 5. Read the cart first, then add only the shortfall. */
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var already = 0;
            cart.items.forEach(function (it) {
              if (String(it.variant_id) === variantId) already += it.quantity;
            });
            var room = MAX - already;
            if (room <= 0) {
              var err = new Error('at-cap');
              err.atCap = true;
              throw err;
            }
            formData.set('quantity', Math.min(wanted, room));
            return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: formData
            });
          })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            addBtn.disabled = false;
            if (data.status) {
              if (message) {
                message.style.display = 'block';
                message.textContent = data.description || 'That combination is unavailable.';
                message.style.color = '#b03434';
              }
              return;
            }
            if (message) {
              message.style.display = 'block';
              message.style.color = 'var(--text)';
              message.textContent = 'Added to your bag.';
            }
            updateCartCount();
            /* Brief "Added" morph before the drawer opens.
               The label is restored from data-label-available (captured once at
               init), NOT from the button's current text — on a second add
               within the 1100ms window the current text is still "Added ✓",
               which would otherwise get latched in as the permanent label.
               Timers are cleared for the same reason: overlapping adds must not
               leave two restores racing each other. */
            clearTimeout(addedOpenTimer);
            clearTimeout(addedResetTimer);
            addBtn.textContent = 'Added ✓';
            addBtn.classList.add('is-added');
            addedOpenTimer = setTimeout(function () {
              if (window.VirootOpenCartDrawer) window.VirootOpenCartDrawer();
            }, 320);
            addedResetTimer = setTimeout(function () {
              addBtn.classList.remove('is-added');
              addBtn.textContent = addBtn.getAttribute('data-label-available');
            }, 1100);
          })
          .catch(function (err) {
            addBtn.disabled = false;
            /* Hitting the cap is an expected outcome, not a failure — say so
               plainly instead of leaving the button looking like it did nothing. */
            if (err && err.atCap && message) {
              message.style.display = 'block';
              message.style.color = '#b03434';
              message.textContent = 'You already have the maximum of ' +
                window.VIROOT_MAX_PER_ITEM + ' of this item in your bag.';
            }
          });
      });
    }
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          window.virootSetCartCount(el, cart.item_count);
        });
      })
      .catch(function () {});
  }

  /* ---------------------------------------------------------------------
     COLLECTION FILTERS PANEL
  --------------------------------------------------------------------- */
  function initFilters() {
    var toggle = document.querySelector('[data-filters-toggle]');
    var panel = document.querySelector('[data-filters-panel]');
    var overlay = document.querySelector('[data-filters-overlay]');
    var closeBtn = document.querySelector('[data-filters-close]');
    function setOpen(open) {
      panel.hidden = !open;
      if (overlay) overlay.hidden = !open;
    }
    if (toggle && panel) {
      toggle.addEventListener('click', function () { setOpen(panel.hidden); });
      if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
      if (overlay) overlay.addEventListener('click', function () { setOpen(false); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) setOpen(false);
      });
    }
    var form = document.querySelector('[data-filter-form]');
    if (form) {
      form.querySelectorAll('[data-filter-input]').forEach(function (input) {
        input.addEventListener('change', function () {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initAccordions();
    initProductQty();
    initCartQty();
    initVariantPicker();
    initFilters();
  });
})();

/* VIROOT reveal-on-scroll */
(function(){
  if (!('IntersectionObserver' in window)) return;
  var els = document.querySelectorAll('.wv-card, .fn-card, .origin-led-item, .jcard, .oo-h, .fo-head-row, .kw-h, .bundle, .vmap-fig, .origin-passport-stamp');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin:'0px 0px -8% 0px' });
  els.forEach(function(el){ el.classList.add('v-reveal'); io.observe(el); });
})();

/* ============================== VIROOT cart drawer ============================== */
(function(){
  var drawer=document.querySelector('[data-cart-drawer]');
  if(!drawer) return;
  var overlay=document.querySelector('[data-cart-drawer-overlay]');
  var itemsEl=drawer.querySelector('[data-cart-drawer-items]');
  var emptyEl=drawer.querySelector('[data-cart-drawer-empty]');
  var footEl=drawer.querySelector('[data-cart-drawer-foot]');
  var totalEl=drawer.querySelector('[data-cart-drawer-total]');

  function money(c){ var n=Math.round(c)/100,s=(n%1===0?String(n):n.toFixed(2)),p=s.split('.'),i=p[0],l=i.length>3?i.slice(-3):i,rr=i.length>3?i.slice(0,-3):''; if(rr) l=rr.replace(/\B(?=(\d{2})+(?!\d))/g,',')+','+l; return '₹ '+l+(p[1]?'.'+p[1]:''); }
  function cdEsc(x){ return String(x==null?'':x).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function fmtSize(s){ if(!s) return s; return String(s).replace(/grams?\s+each/gi,'g each').replace(/grams?/gi,'g').replace(/(\d)\s*g/gi,'$1 g').replace(/\s+/g,' ').trim(); }

  function render(cart){
    var counts=document.querySelectorAll('[data-cart-count]');
    counts.forEach(function(el){ window.virootSetCartCount(el, cart.item_count); });
    if(cart.item_count===0){ itemsEl.innerHTML=''; emptyEl.hidden=false; footEl.style.display='none'; return; }
    emptyEl.hidden=true; footEl.style.display='';
    totalEl.textContent=money(cart.total_price);
    itemsEl.innerHTML=cart.items.map(function(it){
      var img=it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2') : '';
      var unit = it.quantity > 0 ? Math.round(it.final_line_price / it.quantity) : it.final_price;
      return '<div class="cd-line" data-line-key="'+cdEsc(it.key)+'" data-unit="'+unit+'">'+
        (img?'<img src="'+cdEsc(img)+'" alt="">':'<div style="width:64px;height:80px;background:var(--bg-alt);flex-shrink:0;"></div>')+
        '<div class="cd-line-info">'+
          '<div class="cd-line-title">'+cdEsc(String(it.product_title).replace(/^VIROOT\s+/i,''))+'</div>'+
          (it.variant_title && it.variant_title!=='Default Title' ? '<div class="cd-line-price" style="color:rgba(74,61,49,.55)">'+cdEsc(fmtSize(it.variant_title))+'</div>' : '')+
          '<div class="cd-line-price cd-line-amt">'+money(it.final_line_price)+'</div>'+
          '<div class="cd-line-qty">'+
            '<button type="button" data-cd-minus aria-label="Decrease">−</button>'+
            '<input class="cd-qty-input" type="number" min="0" max="'+window.VIROOT_MAX_PER_ITEM+'" inputmode="numeric" data-cd-qty value="'+(parseInt(it.quantity,10)||0)+'" aria-label="Quantity">'+
            '<button type="button" data-cd-plus aria-label="Increase">+</button>'+
          '</div>'+
          '<button type="button" class="cd-line-rm" data-cd-remove>Remove</button>'+
        '</div></div>';
    }).join('');
  }

  function refresh(){ return fetch('/cart.js').then(function(r){return r.json();}).then(render); }

  function open(){ refresh().then(function(){ drawer.hidden=false; overlay.hidden=false; requestAnimationFrame(function(){ drawer.classList.add('open'); overlay.classList.add('open'); }); document.body.style.overflow='hidden'; }); }
  function close(){ drawer.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow=''; setTimeout(function(){ drawer.hidden=true; overlay.hidden=true; },350); }

  window.VirootOpenCartDrawer = open;
  document.querySelectorAll('.hdr-cart-link').forEach(function(a){
    a.addEventListener('click', function(e){ e.preventDefault(); open(); });
  });
  drawer.querySelector('[data-cart-drawer-close]').addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !drawer.hidden) close(); });

  /* Optimistic + debounced quantity edits (instant feel, one batched request). */
  var cdPending=null;
  /* See syncSeq in initCartQty — same out-of-order guard for the drawer. */
  var cdSeq=0;
  function cdRecalc(){
    var total=0, n=0;
    itemsEl.querySelectorAll('.cd-line').forEach(function(line){
      var unit=parseInt(line.getAttribute('data-unit'),10)||0;
      var inp=line.querySelector('[data-cd-qty]');
      var q=Math.max(0,parseInt(inp.value,10)||0);
      total+=unit*q; n+=q;
      var amt=line.querySelector('.cd-line-amt');
      if(amt) amt.textContent=money(unit*q);
      line.style.opacity=q===0?'0.4':'';
    });
    totalEl.textContent=money(total);
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ window.virootSetCartCount(el, n); });
  }
  function cdReconcile(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ window.virootSetCartCount(el, cart.item_count); });
    if(cart.item_count===0){ itemsEl.innerHTML=''; emptyEl.hidden=false; footEl.style.display='none'; return; }
    emptyEl.hidden=true; footEl.style.display='';
    var byKey={}; cart.items.forEach(function(it){ byKey[it.key]=it; });
    var domKeys={};
    itemsEl.querySelectorAll('.cd-line').forEach(function(line){
      var key=line.getAttribute('data-line-key'); domKeys[key]=1;
      var it=byKey[key];
      if(!it){ line.remove(); return; }
      var inp=line.querySelector('[data-cd-qty]');
      if(inp && document.activeElement!==inp) inp.value=it.quantity;
      line.setAttribute('data-unit', it.quantity>0?Math.round(it.final_line_price/it.quantity):it.final_price);
      var amt=line.querySelector('.cd-line-amt');
      if(amt) amt.textContent=money(it.final_line_price);
      line.style.opacity='';
    });
    if(cart.items.some(function(it){ return !domKeys[it.key]; })){ render(cart); }
    totalEl.textContent=money(cart.total_price);
  }
  function cdSync(){
    var updates={};
    itemsEl.querySelectorAll('.cd-line').forEach(function(line){
      updates[line.getAttribute('data-line-key')]=Math.max(0,parseInt(line.querySelector('[data-cd-qty]').value,10)||0);
    });
    var mySeq=++cdSeq;
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:updates})})
      .then(function(r){return r.json();})
      .then(function(cart){ if(mySeq!==cdSeq) return; cdReconcile(cart); })
      .catch(function(){ refresh(); });
  }
  function cdSchedule(){ if(cdPending) clearTimeout(cdPending); cdPending=setTimeout(cdSync,400); }
  function cdSetQty(line,q){ line.querySelector('[data-cd-qty]').value=window.virootClampQty(q,0); cdRecalc(); cdSchedule(); }

  itemsEl.addEventListener('click', function(e){
    var line=e.target.closest('.cd-line'); if(!line) return;
    var q=parseInt(line.querySelector('[data-cd-qty]').value,10)||0;
    if(e.target.closest('[data-cd-plus]')) cdSetQty(line,q+1);
    else if(e.target.closest('[data-cd-minus]')) cdSetQty(line,q-1);
    else if(e.target.closest('[data-cd-remove]')) cdSetQty(line,0);
  });
  itemsEl.addEventListener('input', function(e){
    if(!e.target.closest('[data-cd-qty]')) return; cdRecalc(); cdSchedule();
  });
  itemsEl.addEventListener('change', function(e){
    var inp=e.target.closest('[data-cd-qty]'); if(!inp) return;
    inp.value=window.virootClampQty(inp.value,0); cdRecalc(); cdSchedule();
  });

  /* Intercept add-to-cart so the drawer opens instead of navigating.
     This is the fallback path: clicking "Add to Bag" is handled by the richer
     click handler in initVariantPicker (inline error text, "Added ✓" morph),
     which preventDefault()s the click so this submit never fires. What still
     reaches here is implicit submission — Enter pressed in a field. */
  var form=document.getElementById('ProductForm');
  if(form){
    /* e.submitter is unsupported on Safari <15.4 / Firefox <98, where it is
       undefined. Relying on it alone meant Buy Now failed the checkout test
       below, got preventDefault()ed, and silently added to the bag instead of
       going to checkout. Tracking the last-pressed submit button ourselves
       keeps that path correct on those browsers. */
    var lastSubmitter=null;
    form.addEventListener('click', function(e){
      var b=e.target.closest('button[type="submit"], input[type="submit"]');
      if(b && form.contains(b)) lastSubmitter=b;
    }, true);

    form.addEventListener('submit', function(e){
      var submitter=e.submitter||lastSubmitter;
      if(submitter && submitter.name==='checkout') return; /* Buy Now goes straight to checkout */
      e.preventDefault();
      var fd=new FormData(form);
      fetch('/cart/add.js',{method:'POST',body:fd})
        .then(function(r){return r.json();})
        .then(function(){ open(); })
        .catch(function(){ form.submit(); });
    });
  }
})();

/* ============================== Collection view toggle ============================== */
(function(){
  var toggle=document.querySelector('[data-view-toggle]');
  var grid=document.querySelector('[data-product-grid]');
  if(!toggle||!grid) return;
  var btns=toggle.querySelectorAll('.view-btn');
  function setView(v){
    grid.classList.toggle('pgrid--list', v==='list');
    btns.forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-view')===v); });
    try{ localStorage.setItem('viroot-view', v); }catch(e){}
  }
  btns.forEach(function(b){ b.addEventListener('click', function(){ setView(b.getAttribute('data-view')); }); });
  var saved=null; try{ saved=localStorage.getItem('viroot-view'); }catch(e){}
  if(saved==='list') setView('list');
})();

/* ============================== VIROOT premium motion ============================== */
(function(){
  /* scroll progress hairline */
  var bar=document.createElement('div'); bar.className='v-progress'; bar.innerHTML='<span></span>';
  document.body.appendChild(bar);
  var span=bar.firstChild;
  var hdr=document.querySelector('.hdr');
  var mnavEl=document.querySelector('[data-mobile-nav]');
  var lastScrollY=window.scrollY;
  var reduceMotionHdr=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function onScroll(){
    var h=document.documentElement.scrollHeight - window.innerHeight;
    span.style.width=(h>0 ? (window.scrollY/h*100) : 0)+'%';
    var y=window.scrollY;
    if(hdr){
      hdr.classList.toggle('is-scrolled', y>10);
      /* Smart header: tuck away on upward scroll, reveal on downward scroll.
         Skipped entirely while the mobile drawer is open (it isn't reachable
         while that's open anyway), and skipped under reduced-motion (stays
         put, no hide). */
      var navOpen = mnavEl && mnavEl.classList.contains('open');
      if(!navOpen && !reduceMotionHdr){
        var headerH = hdr.offsetHeight || 55;
        if(y <= headerH){ hdr.classList.remove('hdr--hidden'); }
        else if(y < lastScrollY){ hdr.classList.add('hdr--hidden'); }
        else if(y > lastScrollY){ hdr.classList.remove('hdr--hidden'); }
      }
    }
    lastScrollY=y;
  }
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

  /* stagger reveal delays within groups */
  document.querySelectorAll('.wv-cards, .fn-grid, .pgrid, .vp-recipes, .vp-notes-grid, .ig-grid').forEach(function(group){
    [...group.children].forEach(function(el,i){ el.style.setProperty('--v-delay', (i*0.08)+'s'); });
  });
})();

/* ============================== Country-code searchable dropdown ============================== */
(function(){
  var panel=document.querySelector('.vp-cc-panel');
  if(!panel) return;
  var search=panel.querySelector('.vp-cc-search');
  var items=[].slice.call(panel.querySelectorAll('.vp-cc-item'));
  var activeRow=null;
  function codeOf(v){ var m=v.match(/(\+[\d-]+)\s*$/); return m?m[1]:v; }
  function close(){ if(panel.hidden) return; panel.hidden=true; activeRow=null; }
  function open(row){
    activeRow=row; row.appendChild(panel); panel.hidden=false;
    search.value=''; items.forEach(function(li){ li.style.display=''; });
    search.focus();
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.vp-cc-btn');
    if(btn){
      var row=btn.closest('.vp-phone-row');
      if(activeRow===row && !panel.hidden){ close(); } else { close(); open(row); }
      return;
    }
    var it=e.target.closest('.vp-cc-item');
    if(it && activeRow){
      var v=it.getAttribute('data-v');
      var hid=activeRow.querySelector('.vp-cc-value');
      var b=activeRow.querySelector('.vp-cc-btn');
      if(hid) hid.value=v;
      if(b) b.textContent=codeOf(v);
      close();
      return;
    }
    if(!e.target.closest('.vp-cc-panel')) close();
  });
  search.addEventListener('input',function(){
    var q=search.value.toLowerCase();
    items.forEach(function(li){ li.style.display = li.textContent.toLowerCase().indexOf(q)>-1 ? '' : 'none'; });
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
})();

/* ============================== Header search bar toggle ============================== */
(function(){
  var toggle=document.querySelector('[data-search-toggle]');
  var panel=document.querySelector('[data-search-panel]');
  if(!toggle||!panel) return;
  var input=panel.querySelector('[data-search-input]');
  var closeBtn=panel.querySelector('[data-search-close]');
  function open(){ panel.hidden=false; requestAnimationFrame(function(){ panel.classList.add('open'); if(input) input.focus(); }); }
  function close(){ panel.classList.remove('open'); setTimeout(function(){ panel.hidden=true; }, 250); }
  toggle.addEventListener('click', function(){ panel.hidden ? open() : close(); });
  if(closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !panel.hidden) close(); });
})();

/* PDP image carousel: auto-rotate every 3s + swipe, no thumbnails. */
(function () {
  function initPdpCarousel() {
    var root = document.querySelector('[data-pdp-carousel]');
    if (!root) return;
    var track = root.querySelector('[data-pdp-track]');
    if (!track) return;
    var slides = track.children;
    var n = slides.length;
    if (n < 2) return;
    var dots = root.querySelectorAll('[data-pdp-dot]');
    var i = 0, timer = null, DELAY = 5500;

    function render() {
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
    }
    function go(idx) { i = (idx + n) % n; render(); }
    function next() { go(i + 1); }
    function start() { stop(); timer = setInterval(next, DELAY); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    for (var d = 0; d < dots.length; d++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () { go(idx); start(); });
      })(d);
    }

    var prevBtn = root.querySelector('[data-pdp-prev]');
    var nextBtn = root.querySelector('[data-pdp-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(i - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });

    // Touch swipe
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; stop();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { dx < 0 ? next() : go(i - 1); }
      x0 = null; y0 = null; start();
    }, { passive: true });

    // Pause on hover (desktop)
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    // Pause when tab hidden
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    render();
    start();
  }
  if (document.readyState !== 'loading') { initPdpCarousel(); }
  else { document.addEventListener('DOMContentLoaded', initPdpCarousel); }
})();

/* ============================== VIROOT India origin map ============================== */
/* Fetches the shared India SVG once (cached asset), injects it, and highlights
   the origin state(s) in gold. Same-origin CDN sends CORS headers, so fetch works. */
(function () {
  var figs = document.querySelectorAll('[data-vmap]');
  if (!figs.length) return;
  var cache = {};
  function load(src) {
    if (!cache[src]) {
      cache[src] = fetch(src).then(function (r) { return r.ok ? r.text() : Promise.reject(); });
    }
    return cache[src];
  }
  figs.forEach(function (fig) {
    var src = fig.getAttribute('data-vmap-src');
    var mount = fig.querySelector('.vmap');
    if (!src || !mount || mount.__vmapDone) return;
    var codes = (fig.getAttribute('data-vmap-highlight') || '').trim().split(/\s+/);
    load(src).then(function (svgText) {
      mount.innerHTML = svgText;
      mount.__vmapDone = true;
      codes.forEach(function (code) {
        if (!code) return;
        var p = mount.querySelector('.vmap-state[data-s="' + code + '"]');
        if (p) p.classList.add('is-active');
      });
    }).catch(function () {});
  });
})();

/* ============================== Origin stamps: draggable / swipeable / auto-scrolling shelf ============================== */
(function () {
  /* The retry below waits for the stamps to be laid out (images still loading
     leave scrollWidth at ~0). It must only ever run on a page that actually
     HAS the marquee — the origin-stamps section is on the homepage only, so
     retrying when the element is simply absent spun a 500ms timer forever on
     every other page of the site. Bail on absent; retry only on not-yet-laid-
     out, and give up after ~10s so a genuinely empty strip can't loop either. */
  var tries = 0;
  function init() {
    var marquee = document.querySelector('[data-stamp-marquee]');
    var track = document.querySelector('[data-stamp-track]');
    if (!marquee || !track) return;
    if (track.scrollWidth < 100) {
      if (++tries > 20) return;
      setTimeout(init, 500);
      return;
    }

    var half = track.scrollWidth / 2;
    var autoScroll = true;
    var lastTime = Date.now();
    var resumeTimer = null;
    var SCROLL_SPEED = 16; // px per second — calm drift
    var FRICTION = 2.2;    // higher = flick momentum settles sooner
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    // Drive motion with a GPU transform (sub-pixel, composited → jitter-free)
    // instead of scrollLeft (integer-rounded every frame → shaky). We own the
    // drag too, so disable native horizontal scroll but keep vertical page
    // scroll on touch via touch-action: pan-y.
    var offset = 0;    // total px travelled; wrapped with modulo when applied
    var momentum = 0;  // px/sec carried after a flick, decays to 0
    var dragging = false;

    marquee.style.overflowX = 'hidden';
    marquee.style.touchAction = 'pan-y';
    track.style.willChange = 'transform';

    function apply() {
      var m = offset % half;
      if (m < 0) m += half;
      track.style.transform = 'translateX(' + (-m) + 'px)';
    }
    apply();

    function animate() {
      var now = Date.now();
      // Clamp delta so returning to a backgrounded tab never causes a fast jump.
      var delta = Math.min((now - lastTime) / 1000, 0.05);
      lastTime = now;
      if (!dragging) {
        if (Math.abs(momentum) > 4) {
          // Free-flow glide after a flick, decelerating smoothly.
          offset += momentum * delta;
          momentum *= Math.exp(-delta * FRICTION);
          if (Math.abs(momentum) <= 4) { momentum = 0; autoScroll = true; }
          apply();
        } else if (autoScroll && !reduceMotion) {
          offset += SCROLL_SPEED * delta;
          apply();
        }
      }
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);

    function pauseThenResume() {
      autoScroll = false;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { lastTime = Date.now(); autoScroll = true; }, 1500);
    }

    // Unified pointer drag — one code path for mouse and touch — with inertia.
    var startX = 0, startOffset = 0, moved = false, lastX = 0, lastT = 0, vel = 0;

    marquee.addEventListener('pointerdown', function (e) {
      dragging = true;
      moved = false;
      startX = e.clientX;
      startOffset = offset;
      lastX = e.clientX;
      lastT = Date.now();
      vel = 0;
      momentum = 0;
      autoScroll = false;
      clearTimeout(resumeTimer);
      marquee.classList.add('is-dragging');
      if (marquee.setPointerCapture) { try { marquee.setPointerCapture(e.pointerId); } catch (err) {} }
    });

    marquee.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      offset = startOffset - dx;
      var now = Date.now(), dt = now - lastT;
      if (dt > 0) {
        // Smooth velocity (exponential moving average) so a noisy final sample
        // can't make the flick hand-off jerk.
        var instV = (e.clientX - lastX) / dt; // px per ms
        vel = vel * 0.6 + instV * 0.4;
        lastX = e.clientX;
        lastT = now;
      }
      apply();
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      marquee.classList.remove('is-dragging');
      // If the finger paused before lifting, don't fling — release cleanly.
      if (Date.now() - lastT > 100) vel = 0;
      // Finger velocity (px/ms, + = rightward) → offset momentum (px/s, opposite sign).
      momentum = -vel * 1000;
      var MAX = 3000;
      if (momentum > MAX) momentum = MAX;
      else if (momentum < -MAX) momentum = -MAX;
      if (Math.abs(momentum) <= 4) { momentum = 0; pauseThenResume(); }
    }
    marquee.addEventListener('pointerup', endDrag);
    marquee.addEventListener('pointercancel', endDrag);

    marquee.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    // Desktop: pause the drift while hovering so a stamp isn't a moving target.
    if (canHover) {
      marquee.addEventListener('mouseenter', function () {
        autoScroll = false;
        clearTimeout(resumeTimer);
      });
      marquee.addEventListener('mouseleave', function () {
        if (!dragging) { lastTime = Date.now(); autoScroll = true; }
      });
    }

    // Keyboard: arrow keys nudge the strip (it's focusable via tabindex="0").
    marquee.addEventListener('keydown', function (e) {
      var step = 0;
      if (e.key === 'ArrowLeft') step = -60;
      else if (e.key === 'ArrowRight') step = 60;
      else return;
      e.preventDefault();
      offset += step;
      apply();
      autoScroll = false;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { lastTime = Date.now(); autoScroll = true; }, 1500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================== Home hero carousel ============================== */
(function () {
  function initHeroCarousel() {
    var root = document.querySelector('[data-hero-carousel]');
    if (!root) return;
    var track = root.querySelector('[data-hero-track]');
    if (!track) return;
    var slides = track.children;
    var n = slides.length;
    if (n < 2) return;

    var dots = root.querySelectorAll('[data-hero-dot]');
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    var i = 0, timer = null, DELAY = 9000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Infinite loop.
       go() used to wrap with a modulo, so last -> first animated the track from
       -400% back to 0% — a long rewind past every slide, which read as a glitch
       rather than a loop.

       Instead: clone the last slide in front and the first slide behind, giving
       [4'][0][1][2][3][0']. Stepping off either end animates ONE step onto a
       clone, then snaps transition-free to the identical real slide at the same
       visual position. The viewer only ever sees a single step. */
    var real = [].slice.call(slides);
    var headClone = real[n - 1].cloneNode(true);
    var tailClone = real[0].cloneNode(true);
    [headClone, tailClone].forEach(function (c) {
      c.setAttribute('aria-hidden', 'true');
      var f = c.querySelectorAll('a, button');
      for (var k = 0; k < f.length; k++) f[k].setAttribute('tabindex', '-1');
    });
    track.insertBefore(headClone, real[0]);
    track.appendChild(tailClone);

    function offset(idx) { return -((idx + 1) * 100); }

    function render(animate) {
      // The transition is declared !important in CSS, so an inline
      // transition:none loses to it and the "snap" would animate — which is the
      // rewind this loop exists to avoid. Toggle a class that is !important too.
      if (!animate) track.classList.add('is-snapping');
      track.style.transform = 'translateX(' + offset(i) + '%)';
      if (!animate) { void track.offsetWidth; track.classList.remove('is-snapping'); }
      var active = ((i % n) + n) % n;
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === active);
      // Only the active slide's video plays — keeps multiple hero videos cheap.
      for (var s = 0; s < real.length; s++) {
        var v = real[s].querySelector('video');
        if (!v) continue;
        if (s === active) { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (v.pause) v.pause();
      }
    }

    function normalise() {
      if (i === n) { i = 0; render(false); }
      else if (i === -1) { i = n - 1; render(false); }
    }
    // Once the step onto a clone finishes, jump to the identical real slide.
    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      normalise();
    });

    function go(idx) {
      // Land any in-flight clone step first: a fast click mid-transition would
      // otherwise leave the track parked on a clone with no transitionend due.
      normalise();
      i = idx; render(true);
    }
    function next() { go(i + 1); }
    function start() { stop(); if (!reduce) timer = setInterval(next, DELAY); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    for (var d = 0; d < dots.length; d++) (function (idx) {
      dots[idx].addEventListener('click', function () { go(idx); start(); });
    })(d);
    if (prevBtn) prevBtn.addEventListener('click', function () { go(i - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });

    // Touch swipe (horizontal only, so vertical page scroll is unaffected)
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) next(); else go(i - 1); }
      x0 = null; y0 = null; start();
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    render(false);
    start();
  }

  if (document.readyState !== 'loading') initHeroCarousel();
  else document.addEventListener('DOMContentLoaded', initHeroCarousel);
})();

/* ──────────────────────────────────────────────────────────────
   Collection sort — custom dropdown.

   The native <select> hands sorting to an OS-level popup that
   cannot be styled and looks foreign on the page. We hide it only
   once JS is confirmed running, and drive an ARIA listbox instead,
   so a no-JS visitor keeps a working (if unstyled) control.

   Keyboard follows the listbox pattern: Up/Down move, Home/End jump,
   Enter/Space commit, Escape closes and returns focus to the button.
   ────────────────────────────────────────────────────────────── */
(function () {
  function initSortDropdown() {
    var root = document.querySelector('[data-sort-root]');
    if (!root) return;

    var native = root.querySelector('[data-sort-by]');
    var dd     = root.querySelector('[data-sortdd]');
    var btn    = root.querySelector('[data-sortdd-btn]');
    var list   = root.querySelector('[data-sortdd-list]');
    if (!dd || !btn || !list) return;

    var opts = Array.prototype.slice.call(list.querySelectorAll('[data-sortdd-opt]'));
    if (!opts.length) return;

    // Swap only now that we know the enhancement can actually run.
    if (native) native.hidden = true;
    dd.hidden = false;

    // Reconcile the selected option against the URL, which is the real source
    // of truth for the current sort. Liquid can hand us a blank sort on a first
    // visit, leaving nothing marked; fall back to the first option (Featured).
    var urlSort = null;
    try { urlSort = new URLSearchParams(window.location.search).get('sort_by'); } catch (e) {}
    var selIdx = -1;
    if (urlSort) {
      selIdx = opts.findIndex(function (o) {
        return (o.getAttribute('data-url') || '').indexOf('sort_by=' + urlSort) !== -1;
      });
    }
    if (selIdx < 0) {
      selIdx = opts.findIndex(function (o) {
        return o.getAttribute('aria-selected') === 'true';
      });
    }
    if (selIdx < 0) selIdx = 0;

    opts.forEach(function (o, n) {
      var on = n === selIdx;
      o.setAttribute('aria-selected', on ? 'true' : 'false');
      o.classList.toggle('is-selected', on);
    });
    var cur = document.getElementById('sort-current');
    if (cur) cur.textContent = opts[selIdx].textContent.trim();

    var activeIdx = selIdx;

    function setActive(i, focus) {
      if (i < 0) i = opts.length - 1;
      if (i >= opts.length) i = 0;
      activeIdx = i;
      opts.forEach(function (o, n) { o.classList.toggle('is-active', n === i); });
      if (focus !== false) opts[i].focus();
    }

    function isOpen() { return dd.classList.contains('is-open'); }

    function open() {
      if (isOpen()) return;
      dd.classList.add('is-open');
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      setActive(activeIdx);
    }

    function close(returnFocus) {
      if (!isOpen()) return;
      dd.classList.remove('is-open');
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (returnFocus) btn.focus();
    }

    function commit(i) {
      var url = opts[i] && opts[i].getAttribute('data-url');
      if (url) window.location.href = url;
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      isOpen() ? close(false) : open();
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open();
      }
    });

    list.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); setActive(activeIdx + 1); break;
        case 'ArrowUp':   e.preventDefault(); setActive(activeIdx - 1); break;
        case 'Home':      e.preventDefault(); setActive(0); break;
        case 'End':       e.preventDefault(); setActive(opts.length - 1); break;
        case 'Escape':    e.preventDefault(); close(true); break;
        case 'Tab':       close(false); break;
        case 'Enter':
        case ' ':         e.preventDefault(); commit(activeIdx); break;
      }
    });

    opts.forEach(function (o, i) {
      o.addEventListener('click', function (e) { e.stopPropagation(); commit(i); });
      o.addEventListener('mouseenter', function () { setActive(i, false); });
    });

    document.addEventListener('click', function (e) {
      if (!dd.contains(e.target)) close(false);
    });

    // Focus leaving the whole control closes it — covers shift-tabbing out.
    root.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!root.contains(document.activeElement)) close(false);
      }, 0);
    });
  }

  if (document.readyState !== 'loading') initSortDropdown();
  else document.addEventListener('DOMContentLoaded', initSortDropdown);
})();

/* ============================== Batch lookup ==============================
   Reads a JSON file of packed lots and shows one. Deliberately conservative:
   while the file holds no records the form is disabled and says so, because a
   lookup that answers "not found" for a genuine batch number reads as the pack
   being counterfeit — the opposite of what this feature is for. */
(function () {
  function initBatchLookup() {
    var root = document.querySelector('[data-batch-lookup]');
    if (!root) return;
    var form  = root.querySelector('[data-batch-form]');
    var input = root.querySelector('[data-batch-input]');
    var out   = root.querySelector('[data-batch-out]');
    var src   = root.getAttribute('data-src');
    var data  = null;

    function show(html) { out.innerHTML = html; out.hidden = false; }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function render(b) {
      var rows = [
        ['Spice', b.product], ['Harvest', b.harvest], ['Packed', b.packed],
        ['Pack sizes', b.size], [b.assay_k, b.assay_v]
      ].filter(function (r) { return r[0] && r[1]; });
      var html = '<div class="bl-card"><div class="bl-card-k">Batch ' + esc(b.batch) + '</div><dl class="bl-dl">';
      rows.forEach(function (r) {
        html += '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>';
      });
      html += '</dl>';
      if (b.assay_method) html += '<p class="bl-method">Tested by ' + esc(b.assay_method) + '.</p>';
      if (b.coa) html += '<p><a class="bl-coa" href="' + esc(b.coa) + '" target="_blank" rel="noopener">View the certificate of analysis →</a></p>';
      if (b.handle) html += '<p><a class="bl-coa" href="/products/' + esc(b.handle) + '">See this spice →</a></p>';
      html += '</div>';
      show(html);
    }

    function notFound(q) {
      show(
        '<div class="bl-card bl-card--miss">' +
          '<div class="bl-card-k">No record for &ldquo;' + esc(q) + '&rdquo;</div>' +
          '<p>That may be a typing slip, or a batch packed before we began publishing lots. ' +
          'Send a photograph of the pack to <a href="mailto:viroot23@gmail.com">viroot23@gmail.com</a> ' +
          'and we will trace it by hand.</p>' +
        '</div>'
      );
    }

    function empty() {
      show('<div class="bl-card bl-card--miss"><div class="bl-card-k">Batch lookup is not open yet</div>' +
           '<p>We are still building the lot records behind this page, and would rather show you nothing than show you a guess. ' +
           'It opens with our next packed harvest. Until then, email <a href="mailto:viroot23@gmail.com">viroot23@gmail.com</a> ' +
           'with a batch number and we will look it up by hand.</p></div>');
      input.disabled = true;
      form.querySelector('.bl-btn').disabled = true;
    }

    function lookup(q) {
      var needle = q.trim().toLowerCase().replace(/\s+/g, '');
      if (!needle) return;
      var hit = data.filter(function (b) {
        return String(b.batch || '').toLowerCase().replace(/\s+/g, '') === needle;
      })[0];
      hit ? render(hit) : notFound(q.trim());
    }

    fetch(src, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        data = (j && j.batches) || [];
        if (!data.length) { empty(); return; }
        var pre = new URLSearchParams(location.search).get('batch');
        if (pre) { input.value = pre; lookup(pre); }
      })
      .catch(function () { empty(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (data && data.length) lookup(input.value);
    });
  }

  if (document.readyState !== 'loading') initBatchLookup();
  else document.addEventListener('DOMContentLoaded', initBatchLookup);
})();
